"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.Text = function () {
    react_1.default.createElement(creator_ui_1.Box, null);
};
